import React from 'react';
import { MenuIcon, CpuIcon } from 'lucide-react';
import { useUiStore } from '../../stores/uiStore';
import { useModelStore } from '../../stores/modelStore';
import { Badge } from '../common/ui';
export function Topbar({
  title
}: {
  title: string;
}) {
  const toggleSidebar = useUiStore(s => s.toggleSidebar);
  const models = useModelStore(s => s.models);
  const ccModel = models.find(m => m.isClaudeCodeDefault);
  return <header className="sticky top-0 z-30 flex h-14 items-center gap-3 border-b border-slate-800 bg-slate-950/80 px-4 backdrop-blur" data-id="element-257">
      <button className="rounded-lg p-1.5 text-slate-400 hover:bg-slate-800 lg:hidden" onClick={toggleSidebar} aria-label="打开菜单" data-id="element-258">
        <MenuIcon className="h-5 w-5" data-id="element-259" />
      </button>
      <h1 className="text-base font-semibold text-slate-100" data-id="element-260">{title}</h1>
      <div className="ml-auto flex items-center gap-2" data-id="element-261">
        <span className="hidden text-xs text-slate-500 sm:inline" data-id="element-262">
          Claude Code 当前执行模型
        </span>
        <Badge tone={ccModel ? 'indigo' : 'red'} data-id="element-263">
          <CpuIcon className="h-3 w-3" data-id="element-264" />
          {ccModel ? ccModel.name : '未设置'}
        </Badge>
      </div>
    </header>;
}